import { createAppSelector } from 'app-components/utils/core/reselect';
import type RootState from 'app-components/utils/redux-store/rootState';

import { institutionLoginsSelectors } from '../institution-logins';
import type { InstitutionLogin } from '../institution-logins/institutionLoginsTypes';
import { HOUSESTATS_REDUCER_KEY } from './houseStatsTypes';

type State = Pick<RootState, typeof HOUSESTATS_REDUCER_KEY>;

export const getHouseStatsStore = (state: State) => state[HOUSESTATS_REDUCER_KEY];
export const getResourcesById = (state: State) => getHouseStatsStore(state).resourcesById;
export const getIsLoading = (state: State) => getHouseStatsStore(state).isLoading;
export const getError = (state: State) => getHouseStatsStore(state).error;

export const getZillowFIId = createAppSelector(
  [institutionLoginsSelectors.getInstitutionLoginsById],
  (institutionLogins) =>
    institutionLogins
      .filter((fi: InstitutionLogin) => fi.channel === 'ZILLOW')
      ?.entries()
      ?.next()?.value?.[0],
);

export const getHouse = createAppSelector([getResourcesById], (house) => house?.entries()?.next()?.value?.[1]);
